export const GalleryData = [
    {
        id:1,
        titile:"Couple",
        image: "https://cdn.pixabay.com/photo/2016/10/30/17/49/couple-1783843_640.jpg"
    },
    {
        id:2,
        titile:"Mariage",
        image:"https://cdn.pixabay.com/photo/2017/08/06/20/11/wedding-2595862_640.jpg"
    },
    {
        id:3,
        titile:"Pregnary",
        image:"https://img.freepik.com/photos-gratuite/femme-enceinte-debout-pres-fenetre-regardant-photo_1157-46771.jpg?size=626&ext=jpg&uid=R94806984&ga=GA1.1.2082906394.1677585481&semt=sph"
    },
    {
        id:4,
        titile:"Baby",
        image:"https://cdn.pixabay.com/photo/2016/11/19/14/28/bed-1839564_640.jpg"
    },
    {
        id:5,
        titile:"Baptized",
        image:"https://cdn.pixabay.com/photo/2018/10/05/23/51/baptized-3727132_640.jpg"
    },
    {
        id:6,
        titile:"Famille",
        image:"https://cdn.pixabay.com/photo/2017/06/27/11/48/team-spirit-2447163_640.jpg"
    },
    
]
